import React, { Component } from 'react';
//import D3Cell from "./D3Cell";
//import { Form, InputGroup, Spinner, Button } from "react-bootstrap";
//import { Button } from "react-bootstrap";

//import EnsResolver from "ens-resolver";

import IPFSImageCell from "../IPFSImageCell/IPFSImageCell";
import P5Cell from "../P5Cell/P5Cell";

import './Grid.css';

const ThreeCell = React.lazy(() => import("../ThreeCell/ThreeCell"));

const METADATA_EVENT = "immutables:metadata";

// Capture metadata from p5 scripts (they output "metadata: {...}")
const originalConsoleLog = console.log.bind(console);
let metadataByTx = {};

/**
 * Traits are collected by listening to what the art script logs, and the store
 * they land in outlives the script that filled it. Change a project's script —
 * which is what an artist does all day in the wizard — and the old script's
 * traits stay in the tally beside the new one's, so the statistics show
 * attributes the work no longer has, each with a single value because only the
 * editions rendered before the change ever had them.
 */
const forgetMetadata = () => { metadataByTx = {}; };

console.log = function(...args) {
  // Capture metadata events from p5 scripts
  if (/^metadata:/.test(args[0])) {
    const entry = args[1];
    if (entry && entry.transactionHash) {
      metadataByTx[entry.transactionHash] = entry;
    }
    try {
      if (typeof window !== "undefined" && typeof window.dispatchEvent === "function") {
        window.dispatchEvent(new CustomEvent(METADATA_EVENT, { detail: { entry } }));
      }
    } catch (error) {
      console.error("Grid - metadata event dispatch failed: ", error);
    }
  }
  // Pass through to original console.log
  originalConsoleLog.apply(console, args);
};

class Grid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maxGridDimension: this.props.maxGridDimension,
      tokens: this.props.tokens,
      length: null,
      square: null,
      maxSquare: null,
      useSquare: null,
      currentPage: this.props.currentPage,
      totalPages: null,
      paginated: false,
    }
    // console.log("ipfs: ", this.props.projectIdToImageURLBase, this.props.projectIdToImageURLExt, this.props.projectIdUseImageURLInGridView)
    this.handleMetadataEvent = this.handleMetadataEvent.bind(this);
  }

  updateAndNotify = () => {
    // console.log("Grid - maxGridDimension: ", this.props.maxGridDimension)
    let length, square;
    let useSquare, totalPages, paginated;

    try {
      length = this.props.tokens.length;
      totalPages = Math.ceil(length / (this.props.maxGridDimension * this.props.maxGridDimension));

      let tempLength = length;
      if(this.props.currentPage === totalPages) {
        tempLength = length % this.props.maxGridDimension**2;
      }
      if(tempLength !== 0) {
        length = tempLength;
      }
      square = Math.ceil(Math.sqrt(length));
    } catch (error) { length = null; };

    //const currentPage = this.props.currentPage;
    const maxSquare = this.props.maxGridDimension;

    if(maxSquare < square) { // we need to paginate
      useSquare = maxSquare;
      totalPages = Math.ceil(length / (this.props.maxGridDimension * this.props.maxGridDimension));
      paginated = true;

    } else { // we dont need to paginate
      useSquare = square;
      totalPages = 1;
      paginated = false;
    }

    // console.log("Grid - useSquare, currentPage, totalPages, paginated: ", useSquare, this.props.currentPage, totalPages, paginated)

    this.setState({
      tokens: this.props.tokens,
      maxGridDimension: this.props.maxGridDimension,
      length,
      square,
      maxSquare,
      useSquare,
      totalPages,
      paginated,
    })
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      window.addEventListener(METADATA_EVENT, this.handleMetadataEvent);
    }
    this.updateAndNotify();
    this.syncMetadataObject();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.script !== this.props.script) {
      forgetMetadata();
      this.props.setMetadataObject({});
    }
    if (prevProps.tokens !== this.props.tokens || prevProps.maxGridDimension !== this.props.maxGridDimension) {
      this.updateAndNotify();
    }

    if (prevProps.currentPage !== this.props.currentPage) {
      this.setState({currentPage: this.props.currentPage})
      this.updateAndNotify();
    }
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener(METADATA_EVENT, this.handleMetadataEvent);
    }
    if (this.metadataUpdateTimeout) {
      clearTimeout(this.metadataUpdateTimeout);
    }
  }

  handleMetadataEvent(event) {
    const entry = event && event.detail ? event.detail.entry : null;
    if (!entry || !entry.transactionHash) {
      return;
    }
    metadataByTx[entry.transactionHash] = entry;
    // Debounce metadata updates - wait 500ms after last event before updating state
    if (this.metadataUpdateTimeout) {
      clearTimeout(this.metadataUpdateTimeout);
    }
    this.metadataUpdateTimeout = setTimeout(() => {
      this.props.setMetadataObject({ ...metadataByTx });
    }, 500);
  }

  syncMetadataObject() {
    this.props.setMetadataObject({ ...metadataByTx });
  }

  render() {

    const {
        scriptType,
    } = this.props;

    const rows = [];
    if(this.state.length) { // Grid View
      let i = 0;
      for (let y=0; y<this.state.useSquare; y++) {
        const cols = []
        for (let x=0; x<this.state.useSquare; x++) {
          let j = i + ((this.state.currentPage-1) * (this.state.maxGridDimension * this.state.maxGridDimension))
          cols.push(
            <td key={j}>
            {
              (this.props.projectIdToImageURLBase && this.props.projectIdToImageURLExt && this.props.projectIdUseImageURLInGridView === true) ? (
                (this.state.tokens[j]) ? (
                <IPFSImageCell
                  key={this.state.tokens[j].tokenId}
                  square={this.state.useSquare}
                  projectIdToImageURLBase={this.props.projectIdToImageURLBase}
                  indexValue={j+1}
                  token={this.state.tokens[j]}
                  preloadedImage={this.props.preloadedImages && this.props.preloadedImages[this.state.tokens[j].tokenId]}
                  projectIdToImageURLExt={this.props.projectIdToImageURLExt}
                  handleClick={this.props.handleClick}
                  onIPFSUnavailable={this.props.onIPFSUnavailable}
                />
                ) : ("")
              ) : (
                (scriptType === "p5js" && this.state.tokens[j]) ? (
                <P5Cell
                  id="grid-p5cell"
                  key={this.state.tokens[j].tokenId}
                  square={this.state.useSquare}
                  indexValue={j+1}
                  //projectScript={this.props.projectScript}
                  token={this.state.tokens[j]}
                  selected={this.props.selected}
                  handleClick={this.props.handleClick}
                  script={this.props.script}
                  setSelectedEditionMetadata={this.props.setSelectedEditionMetadata}
                />
              ) : (["threejs","vanillajs","glsl"].includes(scriptType) && this.state.tokens[j]) ? (
                <React.Suspense fallback={<div/>}>
                <ThreeCell
                  id="grid-threecell"
                  key={this.state.tokens[j].tokenId}
                  square={this.state.useSquare}
                  indexValue={j+1}
                  token={this.state.tokens[j]}
                  selected={this.props.selected}
                  handleClick={this.props.handleClick}
                  script={this.props.script}
                  scriptType={scriptType}
                  setSelectedEditionMetadata={this.props.setSelectedEditionMetadata}
                />
                </React.Suspense>
              ):("")
            )}
            </td>
          );
          i++;
        }
        rows.push(<tr key={y}>{cols}</tr>);
      }
    } else if (this.state.length !== 0){ // Detail View
      rows.push(
        <tr key={1}>
        <td>
        {
          (this.props.projectIdToImageURLBase && this.props.projectIdToImageURLExt && this.props.clientViewImageURLInDetailView === true) ? (
            (this.state.tokens) ? (
            <IPFSImageCell
              key={`${this.state.tokens.tokenId}-detail`}
              square="1"
              projectIdToImageURLBase={this.props.projectIdToImageURLBase}
              indexValue="0"
              token={this.state.tokens}
              projectIdToImageURLExt={this.props.projectIdToImageURLExt}
              handleClick={this.props.handleClick}
              ownerOfSelectedEdition={this.props.ownerOfSelectedEdition} ownerAsOf={this.props.ownerAsOf}
              selected={this.props.selected}
              onIPFSUnavailable={this.props.onIPFSUnavailable}
            />
            ):("")
          ) : (
            (scriptType === "p5js" && this.state.tokens) ? (
              <P5Cell
                id="grid-p5cell-detail"
                key={`${this.state.tokens.tokenId}-detail`}
                square="1"
                indexValue="0"
                //projectScript={this.props.projectScript}
                token={this.state.tokens}
                selected={this.props.selected}
                handleClick={this.props.handleClick}
                script={this.props.script}
                setSelectedEditionMetadata={this.props.setSelectedEditionMetadata}
                ownerOfSelectedEdition={this.props.ownerOfSelectedEdition} ownerAsOf={this.props.ownerAsOf}
              />
            ) : (["threejs","vanillajs","glsl"].includes(scriptType) && this.state.tokens) ? (
              <React.Suspense fallback={<div/>}>
              <ThreeCell
                id="grid-threecell-detail"
                key={`${this.state.tokens.tokenId}-detail`}
                square="1"
                indexValue="0"
                token={this.state.tokens}
                selected={this.props.selected}
                handleClick={this.props.handleClick}
                script={this.props.script}
                scriptType={scriptType}
                setSelectedEditionMetadata={this.props.setSelectedEditionMetadata}
                ownerOfSelectedEdition={this.props.ownerOfSelectedEdition} ownerAsOf={this.props.ownerAsOf}
              />
              </React.Suspense>
            ) : ("")
          )
        }
        </td>
        </tr>
      )
    } else {
      rows.push(
        <tr key={0}>
        <td>
        No Editions minted.  Be the first.
        </td>
        </tr>
      )
    }

    return (

      <div className="center">
        <div>
          <table className={`gridTable ${this.props.selected && 'selected'}`}>
            <tbody>
              {rows}
            </tbody>
          </table>

        </div>
      </div>

    )
  }
}

export default Grid;
